import React, { useContext } from "react";
import { LanguageContext, text } from "../../../container/language";

const ArticleSubtitle = ({ data }) => {
  const { userLanguage } = useContext(LanguageContext);
  const { headerAlignment } = data;
  return (
    <div className="text">
      <h3 className={`section__title ${headerAlignment.toLowerCase()}`}>
        {text(data.text, userLanguage)}
      </h3>
    </div>
  );
};

export default ArticleSubtitle;
